/** Canonical (AWS-style) Secret Manager id of an Atlas project's admin service
 * account client secret. Other providers rewrite it with their `replacer`. */
export const mongodbAtlasAiClientSecretSecretId = (projectId: string): string =>
  `p0/install/mongodb-atlas/${projectId}/client-secret`;

/** Canonical prefix that every token secret of an Atlas project starts with.
 * Other providers rewrite it with their `replacer`. */
export const mongodbAtlasAiAccessTokenPrefix = (projectId: string): string =>
  `p0/access-token/mongodb-atlas/${projectId}/`;

/** The connector's Cloud Run service name. Its Lambda function name adds
 * "-aws". */
export const mongodbAtlasAiConnectorName = "p0-connector-mongodb-atlas-ai";
